import React from "react";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { ChecklistValue } from "./checklistTypes";
import { DisplayTextRow } from "./DisplayTextRow";

type ChecklistCompactDisplayProps = {
  value: ChecklistValue[];
  label: string;
};

export const ChecklistCompactDisplay = ({
  value,
  label,
}: ChecklistCompactDisplayProps) => {
  return (
    <View style={{ marginVertical: 8, gap: 6 }}>
      {value.map((checklist) => {
        const checklistItems = checklist.items ? checklist.items : [];
        const checklistTotal = checklistItems.length;
        const checklistDone = checklistItems.filter(
          (item) => item.checked,
        ).length;

        return (
          <DisplayTextRow key={checklist.id} label={checklist.title || label}>
            <Text variant="bodyMedium">{`${checklistDone}/${checklistTotal}`}</Text>
          </DisplayTextRow>
        );
      })}
    </View>
  );
};
